/**
 * Whether a visit belongs to the Offsite Transfers facility.
 * Mirrors the PRP convention: an offsite visit's `typeOfCare` is the hospital
 * (department) the patient is transferred to, and every Offsite Transfers
 * department name contains "hospital".
 */
export const isOffsiteTypeOfCare = (typeOfCare?: string): boolean =>
  !!typeOfCare?.toLowerCase()?.includes("hospital");
